import { atom } from "jotai";

const orderToAssignAtom = atom<string | undefined>(undefined);

export { orderToAssignAtom };
